import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InfoField, InfoFieldItem } from '../../../../../components/shared/info-field/info-field';
import { TrackClickDirective } from '../../../../../directives/track-click.directive';
import { FormatterHelperService } from '../../../../../services/helpers/formatter-helper.service';

@Component({
  selector: 'app-lead-details-pa',
  standalone: true,
  imports: [InfoField, TrackClickDirective],
  templateUrl: './leads-details-pa.html',
  styleUrls: ['../shared/lead-detail-shared.scss', './leads-details-pa.scss'],
})
export class LeadsDetailsPa {
  leadInfo: Record<string, InfoFieldItem[]> = {};
  financingInfo: Record<string, InfoFieldItem[]> = {};
  @Output() navigate = new EventEmitter<number>();
  @Output() generateSimulation = new EventEmitter<void>();

  @Input() set details(value: any) {
    if (value) {
      this.mapDetails(value);
    }
  }

  constructor(private readonly formatter: FormatterHelperService) {}

  private mapDetails(details: any): void {
    this.leadInfo = {
      linha1: [
        {
          type: 'image',
          imageUrl: details.renovaMais ? 'assets/images/renewalBlue.png' : 'assets/images/renewalGray.png',
          imageAlt: details.renovaMais ? 'Renova Mais Ativo' : 'Renova Mais Inativo',
        },
        { type: 'text', title: 'Nome', info: details.nome || '-' },
        { type: 'text', title: 'CPF', info: this.formatter.CPF(details.cpf) },
        { type: 'text', title: 'Data Nasc.', info: this.formatter.data(details.dataNascimento) },
        { type: 'text', title: 'Tipo Pessoa', info: details.tipoPessoa || '-' },
        { type: 'text', title: 'Data Criação', info: this.formatter.data(details.dataCriacao) },
        { type: 'text', title: 'DN', info: details.dn ? `${details.dn.toString().padStart(4, '0')}` : '-' },
        { type: 'text', title: 'Preferência de Contato', info: details.preferenciaContato || '-' },
      ],
      linha2: [
        { type: 'status', title: 'Status', info: details.statusDoLead || '-', leadId: details.idLead },
        { type: 'text', title: 'Celular', info: this.formatter.celular(details.celular) },
        { type: 'text', title: 'Tel. Residencial', info: this.formatter.telefone(details.telefoneResidencial) },
        { type: 'text', title: 'Tel. Comercial', info: this.formatter.telefone(details.telefoneComercial) },
        { type: 'text', title: 'Tel. Adicional', info: this.formatter.telefone(details.telefoneAdicional) },
        { type: 'text', title: 'Email', info: details.email || '-' },
      ],
      linha3: [
        { type: 'text', title: 'CEP', info: this.formatter.CEP(details.cep) },
        { type: 'text', title: 'Estado', info: details.estado || '-' },
        { type: 'text', title: 'Cidade', info: details.cidade || '-' },
      ],
    };

    this.financingInfo = {
      linha1: [
        { type: 'text', title: 'Número da proposta', info: details.numeroDaProposta || '-' },
        { type: 'text', title: 'Data da Proposta', info: this.formatter.data(details.dataProposta) },
        { type: 'text', title: 'Tipo de Uso', info: details.tipoUso || '-' },
        { type: 'text', title: 'Nome do Vendedor', info: details.nomeDoVendedor || '-' },
      ],
      linha2: [
        { type: 'text', title: 'Marca', info: details.marca || '-' },
        { type: 'text', title: 'Modelo', info: details.modeloGrupo || '-' },
        { type: 'text', title: 'Modelo Completo', info: details.modeloCompleto || '-' },
        { type: 'text', title: 'Versão', info: details.versao || '-' },
        { type: 'text', title: 'Ano Fabricação', info: details.anoFabricacao?.toString() || '-' },
        { type: 'text', title: 'Ano Modelo', info: details.anoModelo?.toString() || '-' },
      ],
      linha3: [
        { type: 'text', title: 'Valor Entrada', info: this.formatter.moeda(details.valorEntrada) },
        { type: 'text', title: 'Parcelas', info: details.quantidadeParcelas ? `${details.quantidadeParcelas}x` : '-' },
        { type: 'text', title: 'Valor veículo', info: this.formatter.moeda(details.valorVeiculo) },
        { type: 'text', title: 'Valor Financiado', info: this.formatter.moeda(details.valorFinanciado) },
      ],
    };
  }
}
